(() => {
  if (customElements.get('row-slider')) {
    return;
  }

  class RowSlider extends HTMLElement {
    constructor() {
      super();
      this.slider = null;
      this.options = {};
    }

    connectedCallback() {
      this.initSlider();
    }

    initSlider() {
      if (!this.querySelector('[data-slider]')) return;

      this.options = {
        loop: true,
        autoHeight: true,       
        slidesPerView: 1.25,
        pagination: {
          enabled: false
        },
        navigation: {
          enabled: false
        },
        breakpoints: {
          768: {
            autoHeight: false,
            slidesPerView: 1,
            navigation: {
              enabled: true,
              prevEl: this.querySelector('.swiper-arrow--prev'),
              nextEl: this.querySelector('.swiper-arrow--next'),
            },
            pagination: {
              clickable: true,
              enabled: true,
              // dynamicBullets: true,
              el: this.querySelector('.swiper-pagination'),
            },
          }
        }
      };

      this.slider = new Swiper(
        this.querySelector('[data-slider]'),
        this.options,
      );
    }
  }

  customElements.define('row-slider', RowSlider);
})();
